import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist/lib/storage";

import config from "../helpers/config";

import rootReducer from "./reducers";
import rootSaga from "./sagas";

/** Do not persist login/SSO error blobs — they rehydrate as stale "Alert" and hide fresh API messages after redirect. */
const authenticationPersistTransform = createTransform(
  (inboundState) => {
    if (!inboundState || typeof inboundState !== "object") return inboundState;
    const { error: _e, ...rest } = inboundState;
    return rest;
  },
  (outboundState) => outboundState,
  { whitelist: ["authentication"] }
);

const persistConfigData = {
  key: config.store_name,
  storage,
  whitelist: ["authentication"],
  transforms: [authenticationPersistTransform],
};

const sagaMiddleware = createSagaMiddleware();

let middleware = null;

// loading required middlewares depending upon the environment
// if (process.env.NODE_ENV === "production") {
//   middleware = applyMiddleware(
//     thunk,
//     sagaMiddleware
//   );
// } else {
middleware = composeWithDevTools(
  applyMiddleware(
    sagaMiddleware
  )
);
// }

const pReducer = persistReducer(persistConfigData, rootReducer);

// creating the main/central store
export const store = createStore(pReducer, middleware);

export const persistor = persistStore(store);

// running saga.
sagaMiddleware.run(rootSaga);
